/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { EmailTestFormValues } from './EmailTestPage.types';

export const initialValues: EmailTestFormValues = {
  email: '',
  subject: '',
  html: '',
};

export const emailTestValidationSchema = Yup.object({
  email: Yup.string().trim().required('empty'),
  subject: Yup.string().trim().required('empty'),
  html: Yup.string().trim().required('empty'),
});
